export default __webpack_public_path__ + "static/media/SingleLegSquat.7d229194.png";